module.exports = __webpack_public_path__ + "static/media/tocaText.3dba2de8.png";